import React from 'react';
import { ThemeProvider } from '@mui/material';
import theme from './Theme/theme';
import AppRoutes from './Routes/Routes';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
